import { createContext, useContext, useState } from "react";
import { translations } from "@/i18n";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [locale, setLocale] = useState("en");
  const t = translations[locale];
  const toggle = () => setLocale((l) => (l === "en" ? "nl" : "en"));
  return (
    <LangContext.Provider value={{ locale, setLocale, toggle, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
